import { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import toast from 'react-hot-toast'
import { Copy, Download, X } from 'lucide-react'
import { foodTrainerRegisterUrl } from '../utils/foodTrainerRef'

type Props = {
  trainer: { firstName?: string; lastName?: string; trainerCode?: string }
  onClose: () => void
}

export default function TrainerQrPanel({ trainer, onClose }: Props) {
  const url = foodTrainerRegisterUrl(String(trainer.trainerCode || ''))
  const [dataUrl, setDataUrl] = useState('')

  useEffect(() => {
    let cancelled = false
    import('qrcode').then((mod: any) => {
      const toDataURL = mod.toDataURL || mod.default?.toDataURL
      return toDataURL(url, { width: 280, margin: 1, errorCorrectionLevel: 'M' })
    })
      .then((png) => { if (!cancelled) setDataUrl(png) })
      .catch(() => { if (!cancelled) setDataUrl('') })
    return () => { cancelled = true }
  }, [url])

  const download = () => {
    if (!dataUrl) return
    const a = document.createElement('a')
    a.href = dataUrl
    a.download = `${trainer.trainerCode || 'entrenador'}-food-qr.png`
    a.click()
  }

  const copyLink = () => {
    if (!url) return
    navigator.clipboard.writeText(url)
    toast.success('Enlace de registro copiado')
  }

  return createPortal(
    <div className="food-plan-root food-portal-modal fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4">
      <div className="bg-white border border-slate-200 rounded-2xl p-5 w-full max-w-sm shadow-xl text-[#111827]">
        <div className="flex items-start justify-between mb-3">
          <div>
            <h3 className="font-bold text-gray-800">QR de registro</h3>
            <p className="text-sm text-gray-500">{trainer.firstName} {trainer.lastName}</p>
            <p className="text-xs font-mono text-primary-700 mt-1">{trainer.trainerCode}</p>
          </div>
          <button type="button" onClick={onClose} className="p-1 text-gray-400 hover:text-gray-700"><X size={18} /></button>
        </div>
        <div className="flex justify-center bg-white border border-slate-100 rounded-xl p-3 min-h-[200px]">
          {dataUrl
            ? <img src={dataUrl} alt={`QR ${trainer.trainerCode}`} width={220} height={220} />
            : <p className="text-sm text-gray-400 self-center">Generando QR…</p>}
        </div>
        <p className="text-[11px] text-gray-500 break-all mt-3">{url}</p>
        <div className="flex flex-wrap gap-2 mt-4">
          <button type="button" onClick={onClose} className="btn-secondary flex-1">Cerrar</button>
          <button type="button" onClick={copyLink} className="btn-secondary flex-1 flex items-center justify-center gap-1">
            <Copy size={14} /> Copiar enlace
          </button>
          <button type="button" onClick={download} disabled={!dataUrl} className="btn-primary w-full flex items-center justify-center gap-1">
            <Download size={14} /> Descargar
          </button>
        </div>
      </div>
    </div>,
    document.body,
  )
}
